export const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full min-h-[200px] gap-3">
      <div className="relative">
        {/* Outer ring */}
        <div className="w-9 h-9 rounded-full border-2 border-line" />
        {/* Spinning arc */}
        <svg
          className="absolute inset-0 animate-spin w-9 h-9 text-primary"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="17"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="80 26"
          />
        </svg>
      </div>
      <p className="text-xs font-medium text-ink-muted animate-pulse-soft">
        Loading…
      </p>
    </div>
  );
};
